<!-- Presentational checkbox component that does not modify the plan directly -->
<template>
	<div class="w-full">
		<div
			v-if="plan && product"
			class="flex w-full items-center justify-between rounded-lg border-2 bg-white p-3 shadow-md"
			:class="modelValue ? 'border-accent-500' : 'border-transparent'"
		>
			<div>
				<input
					type="checkbox"
					class="text-accent-400 focus:ring-accent-400 h-5 w-5 cursor-pointer rounded-sm border border-solid border-gray-300"
					:checked="!!modelValue"
					@change="
						$emit(
							'update:modelValue',
							($event.target as HTMLInputElement)?.checked
						)
					"
				/>
				<!-- Name -->
				<span class="text-secondary-900 ml-3 text-sm">
					{{ plan.firstName }} {{ plan.lastName }}
				</span>
			</div>

			<!-- Price -->
			<div
				class="text-primary-700 flex w-1/3 items-center justify-end text-sm font-semibold"
			>
				<div class="text-slate-500">
					{{ getPrice() }}
				</div>
			</div>
		</div>
		<div v-else>{{ t('merchandise.missingPlanOrProduct') }}</div>
	</div>
</template>

<script setup lang="ts">
import type { PbLineItem } from '@/apiTypes'
import type Plan from '@/classes/Plan'
import { PbProductType } from '@/enums/PbProductType'
import { usePresentationLocale } from '@/i18n'
import { useMerchandise } from '@/mixins/merchandise'
import { useCartStore } from '@/stores/cart'

const { t } = usePresentationLocale()
const cartStore = useCartStore()

const props = defineProps<{
	plan: Plan
	product: PbLineItem
}>()

const modelValue = defineModel<boolean>()
const { formatPrice } = useMerchandise()

const getPrice = () => {
	if (
		props.product?.category === PbProductType.Everplans &&
		props.plan &&
		cartStore.cart[props.plan.id]?.includesFreeEverplansPremium
	) {
		return t('reviewSlide.included')
	}

	return formatPrice(props.product?.fixedPrice)
}
</script>
